module.exports = __webpack_public_path__ + "static/dashboard-9e3d5af6b08b0aa78d4b110289fcaaaf.png";